
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'BtnCheckbox',
  props: {
    modelValue: {
      type: Object as PropType<string | string[]>,
    },
    options: {
      type: Array as PropType<{ label: string; value: string }[]>,
      default: () => [],
    },
    selection: {
      type: String as PropType<'single' | 'multiple'>,
      default: 'single',
    },
  },
  emits: ['update:model-value'],
  data(): {
    value?: string | string[];
  } {
    return {
      value: this.modelValue,
    };
  },
  computed: {
    isSelected() {
      return (value: string) => {
        return this.selection == 'single'
          ? value == this.value
          : (this.value as string[])?.some((x) => x == value);
      };
    },
  },
  methods: {
    toggle(value: string) {
      if (!this.value) this.value = [];
      let index = (this.value as string[]).findIndex((x) => x == value);
      if (index == -1) {
        (this.value as string[]).push(value);
      } else {
        (this.value as string[]).splice(index, 1);
      }
      this.emit();
    },
    emit() {
      this.$emit('update:model-value', this.value);
    },
  },
});
